import React, { useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import Receipt from './ReceiptTemplateOne';
import PrintIcon from '@mui/icons-material/Print';
import PrinterOffIcon from '@mui/icons-material/PrintDisabled'; // MUI red icon

const PrintReceipt = ({ data, color = 'black', size = '25px' }) => {
    const contentRef = useRef();
    const [printerAvailable, setPrinterAvailable] = useState(true);

    const handlePrint = useReactToPrint({
        content: () => contentRef.current, // ✅ this is correct
        documentTitle: 'Receipt',
        onAfterPrint: () => {
            console.log('Print success');
            setPrinterAvailable(true);
        },
        onPrintError: (err) => {
            console.error('Print failed', err);
            setPrinterAvailable(false); // 🔴 Mark printer as unavailable
        }
    });

    return (
        <div>
            {/* Hidden printable content */}
            <div style={{ display: 'none' }}>
                <Receipt ref={contentRef} data={data} />
            </div>

            {/* Print Button / Status */}
            <div>
                {printerAvailable ? <PrintIcon
                    onClick={handlePrint}
                    sx={{
                        height: size,
                        width: size,
                        cursor: 'pointer',
                        color: printerAvailable ? color : 'gray'
                    }}
                /> : <PrinterOffIcon sx={{ height: size, width: size, color: 'red', marginLeft: '10px' }} />}

            </div>
        </div>
    );
};

export default PrintReceipt;